import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ErrorPageComponent } from "./components/pages/error-page/error-page.component";
import { CaseStudiesThreeColumnsPageComponent } from "./components/pages/case-studies-three-columns-page/case-studies-three-columns-page.component";
import { FooterComponent } from "./components/layouts/footer/footer.component";
import { PreloaderComponent } from "./components/layouts/preloader/preloader.component";
import { HomepageOneComponent } from "./components/pages/homepage-one/homepage-one.component";
import { HomeoneServicesComponent } from "./components/pages/homepage-one/homeone-services/homeone-services.component";
import { HomeoneProcessComponent } from "./components/pages/homepage-one/homeone-process/homeone-process.component";
import { HomeonePartnerComponent } from "./components/pages/homepage-one/homeone-partner/homeone-partner.component";
import { HomeoneBlogComponent } from "./components/pages/homepage-one/homeone-blog/homeone-blog.component";
import { HomeoneAboutComponent } from "./components/pages/homepage-one/homeone-about/homeone-about.component";
import { HomeoneBannerComponent } from "./components/pages/homepage-one/homeone-banner/homeone-banner.component";
import { AboutPageComponent } from "./components/pages/about-page/about-page.component";
import { CaseStudiesDetailsPageComponent } from "./components/pages/case-studies-details-page/case-studies-details-page.component";
import { FaqPageComponent } from "./components/pages/faq-page/faq-page.component";
import { ServicesDetailsFactomesComponent } from "./services-details-factomes/services-details-factomes.component";
import { ServiceIAComponent } from "./Dashboard/service-ia.component";
import { InductiveDetailsComponent } from "./components/pages/homepage-one/inductive-details/inductive-details.component";
import { AWSComponent } from "./components/pages/homepage-one/aws/aws.component";
import { Testimonialcase2Component } from "./components/pages/testimonialcase2/testimonialcase2.component";
import { Testimonialcase3Component } from "./components/pages/testimonialcase3/testimonialcase3.component";
import { Testimonialcase4Component } from "./components/pages/testimonialcase4/testimonialcase4.component";
import { NavbarComponent } from "./components/layouts/navbar/navbar.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NgxCaptchaModule } from "ngx-captcha";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule } from "@angular/forms";
import { ToastrModule } from "ngx-toastr";
import { PrivacyComponent } from "./privacy/privacy.component";
import { TermsComponent } from "./terms/terms.component";
import { Testing2Component } from "./testing2/testing2.component";
import { BasicComponent } from "./basic/basic.component";
import { InterimediateComponent } from "./interimediate/interimediate.component";
import { AdvanceComponent } from "./advance/advance.component";
import { AddOnServiceComponent } from "./add-on-service/add-on-service.component";
import { BookDemoPageComponent } from "./components/book-demo-page/book-demo-page.component";
import { HttpClientModule } from "@angular/common/http";
import { TryitnowComponent } from "./components/tryitnow/tryitnow.component";
import { LandingPageNewComponent } from "./components/landing-page-new/landing-page-new.component";
import { ServiceDetailsFactoLakeComponent } from "./components/pages/service-details-facto-lake/service-details-facto-lake.component";
import { ServiceDetailsFactoplanComponent } from "./components/pages/service-details-factoplan/service-details-factoplan.component";
import { ThankYouComponent } from "./components/layouts/thank-you/thank-you.component";
import { ServiceDetailsFactoVisionComponent } from "./components/pages/service-details-facto-vision/service-details-facto-vision.component";
import { ServiceDetailsFactoIQComponent } from "./components/pages/service-details-facto-iq/service-details-facto-iq.component";
import { SCADALandingPageComponent } from "./scadalanding-page/scadalanding-page.component";
import { HomeoneTestimonialsComponent } from "./components/pages/homepage-one/homeone-testimonials/homeone-testimonials.component";

@NgModule({
    declarations: [
        AppComponent,
        ErrorPageComponent,
        CaseStudiesThreeColumnsPageComponent,
        FooterComponent,
        PreloaderComponent,
        HomepageOneComponent,
        HomeoneServicesComponent,
        HomeoneProcessComponent,
        HomeonePartnerComponent,
        HomeoneBlogComponent,
        HomeoneAboutComponent,
        HomeoneBannerComponent,
        AboutPageComponent,
        CaseStudiesDetailsPageComponent,
        FaqPageComponent,
        ServicesDetailsFactomesComponent,
        ServiceIAComponent,
        InductiveDetailsComponent,
        AWSComponent,
        Testimonialcase2Component,
        Testimonialcase3Component,
        Testimonialcase4Component,
        NavbarComponent,
        PrivacyComponent,
        TermsComponent,
        Testing2Component,
        BasicComponent,
        InterimediateComponent,
        AdvanceComponent,
        AddOnServiceComponent,
        BookDemoPageComponent,
        TryitnowComponent,
        LandingPageNewComponent,
        ServiceDetailsFactoLakeComponent,
        HomeoneTestimonialsComponent,
        ServiceDetailsFactoplanComponent,
        ThankYouComponent,
        ServiceDetailsFactoVisionComponent,
        ServiceDetailsFactoIQComponent,
        SCADALandingPageComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        NgxCaptchaModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: "toast-top-right",
            preventDuplicates: true,
            progressBar: true,
            closeButton: true,
        }),
    ],
    providers: [],
    bootstrap: [AppComponent],
})
export class AppModule {}
